import React, { useRef, useState } from "react";
import "./index.less";
import { useNavigate } from "react-router-dom";
import SkipBtn from "@/components/SkipBtn";

const BottomPage = () => {


  return (
    <div className="contact_warp">
      <div className="contact_box">
         <p>© 2025 DATA GLOBAL. All rights reserved.</p>
         {/* <SkipBtn path="/contact" text="Contact Us"></SkipBtn> */}
      </div>
    </div>
  );
};

export default BottomPage;
